import DateInput from "@/components/Common/DateInput/DateInput.vue";
import {
  snowTextureItems,
  stateItems
} from "@/configuration/formConfigurations";
import InfoDialog from "@/components/Common/InfoDialog/InfoDialog.vue";

export default {
  components: { InfoDialog, DateInput },
  data: () => ({
    avalancheItems: [
      { id: "low", title: "1 Gering" },
      { id: "moderate", title: "2 Mäßig" },
      { id: "considerable", title: "3 Erheblich" },
      { id: "high", title: "4 Groß" },
      { id: "veryHigh", title: "5 Sehr Groß" }
    ],
    snowTextureItems,
    weatherConditionItems: [
      { id: "bright", title: "Heiter" },
      { id: "slightlyCloudy", title: "Leicht bewölkt" },
      { id: "cloudy", title: "Bewölkt" },
      { id: "foggy", title: "Nebelig" },
      { id: "drizzle", title: "Nieselregen" },
      { id: "shudder", title: "Schauer" },
      { id: "rain", title: "Regen" },
      { id: "snowfall", title: "Schneefall" },
      { id: "lightSnow", title: "Leichter Schneefall" },
      { id: "sleet", title: "Schneeregen" },
      { id: "blizzard", title: "Schneesturm" },
      { id: "cloudless", title: "Wolkenlos" }
    ],
    stateItems
  }),
  props: ["editedItem", "isOwnedBySubPrincipal"]
};
